import React, { useEffect } from 'react';
import { Box, Heading, Text, UnorderedList, ListItem, Flex } from '@chakra-ui/react';
import * as Styles from './styles';
import useEventBus from 'hooks/useEventBus';
export const Terms: React.FC = () => {
  const eventBus = useEventBus();
  useEffect(() => {
    eventBus.dispatchEvent('onChangeTitle', 'Termos de Uso');
  }, []);
  return (
    <Styles.Container>
      <Box m="0 auto" w="100%" maxW="50rem">
        <Box padding="2rem" background="#fff" borderRadius="10px">
          <Heading mb="1rem" size="lg" as="h3">
            TERMOS DE USO E POLÍTICA DE PRIVACIDADE
          </Heading>
          <Heading mb="1rem" size="lg" as="h3">
            Bem-vindo ao DPO HUB!
          </Heading>
          <Text>
            Estes Termos de Uso e Política de Privacidade regulam o acesso e utilização da
            plataforma DPO HUB (“Plataforma”) de titularidade da DANIEL ADVOGADOS, sociedade civil
            de advogados com escritório à Av. República do Chile, 230, 3º andar, Centro - CEP
            20031-170, Rio de Janeiro, Estado do Rio de Janeiro, inscrita no CNPJ
            33.073.800/0001-91, registrada na Ordem dos Advogados do Brasil, Seção do Estado do Rio
            de Janeiro, sob o n° RJ 017.887/2001 (“Daniel”).
          </Text>
          <Text mt="1rem">
            A utilização da plataforma DPO HUB depende de sua aceitação sobre estas regras.
          </Text>
          <Heading mt="1rem" mb="0.5rem" size="sm" as="h4">
            Definições
          </Heading>
          <UnorderedList>
            <ListItem>
              <Text as="b">Cliente:</Text> instituições ou pessoas físicas que contratam os Serviços
              da Equipe Daniel e da Plataforma.
            </ListItem>
            <ListItem>
              <Text as="b">Documentos:</Text> todas as avaliações, relatórios e outros documentos
              que o Usuário possa gerar ou ter acesso por meio da Plataforma.
            </ListItem>
            <ListItem>
              <Text as="b">Equipe Daniel:</Text> advogados e advogadas que prestam serviços de
              assessoria jurídica para os Clientes em nome da Daniel.
            </ListItem>
            <ListItem>
              <Text as="b">Legislação de Privacidade:</Text> é o conjunto de todas as Leis atinentes
              à proteção de dados, como a Constituição Federal de 1988, o Código Civil de 2002, o
              Código de Defesa do Consumidor, a Consolidação das Leis do Trabalho, o Marco Civil da
              Internet e seu Decreto Regulamentador, a Lei Geral de Proteção de Dados Pessoais e
              demais normas setoriais e legais possivelmente atinentes ao tema.
            </ListItem>
            <ListItem>
              <Text as="b">Plataforma:</Text> plataforma DPO HUB acessível pelo site [=].
            </ListItem>
            <ListItem>
              <Text as="b">Serviços:</Text> todos os recursos e serviços prestados pela Daniel por
              meio da Plataforma.
            </ListItem>
            <ListItem>
              <Text as="b">Usuários:</Text> pessoa física indicada pelo Cliente, que possua ou não
              vínculo empregatício com o Cliente, autorizada a acessar a Plataforma, incluindo o
              Usuário Administrador.
            </ListItem>
            <ListItem>
              <Text as="b">Usuário Externo:</Text> pessoa física indicada pelo Cliente, que possua
              ou não vínculo empregatício com o Cliente, autorizada a acessar a Plataforma,
              incluindo o Usuário Administrador.
            </ListItem>
            <ListItem>
              <Text as="b">Usuário Master:</Text> usuário indicado pelo Cliente para criar e
              gerenciar outros Usuários
            </ListItem>
          </UnorderedList>
          <UnorderedList listStyleType="none">
            <ListItem mt="1rem">
              <Text as="b">I. SERVIÇOS</Text>
              <UnorderedList listStyleType="none">
                <ListItem>
                  1.1. A Daniel disponibiliza aos Usuários uma Plataforma que viabiliza que o
                  Cliente realize pré- análises automatizadas sobre tratamento de dados pessoais
                  dentro da sua instituição, submeta esses documentos e gere relatórios
                  (“Documentos”) para avaliação da Equipe Daniel (“Serviços”). A Plataforma é
                  contratada por Clientes, que indicam um Usuário Master para utilizá-la em seu
                  nome.
                </ListItem>

                <ListItem>
                  1.2. O Usuário Administrador, por sua vez, pode criar outros Usuários e gerenciar
                  seus acessos à Plataforma.
                </ListItem>
                <ListItem>
                  1.3. Usuários podem indicar Usuários Externos, ou seja, pessoas físicas sem
                  cadastro na Plataforma, para acessar recursos ou Documentos específicos dentro da
                  Plataforma, por um período determinado no momento do cadastro do Usuário Externo.
                </ListItem>
                <ListItem>
                  1.4. Os Serviços são prestados por meio da Plataforma, que funciona em modalidade
                  de Software as a Service (SaaS) e é hospedado nos servidores da Amazon Web
                  Services (AWS), cujos termos de uso estão disponíveis em:
                  <a href="https://aws.amazon.com/pt/service-terms/.">
                    https://aws.amazon.com/pt/service-terms/.
                  </a>
                </ListItem>
                <ListItem>
                  1.5. Para a prestação dos Serviços, a Daniel poderá contratar terceiros para
                  executar partes de sua operação, como no caso da hospedagem em nuvem dos seus
                  servidores.
                </ListItem>
                <ListItem>
                  1.6. Caso o Cliente tenha contratado os Serviços da Daniel mediante um Contrato
                  específico e assinado (“Contrato”), em caso de eventuais conflitos entre o
                  Contrato e este Instrumento, prevalecerá o disposto no Contrato.
                </ListItem>
                <ListItem>
                  1.7. A extensão dos Serviços prestados dependerá dos perfis de Usuários e Usuários
                  Externos, do plano de Serviços contratado pelo Cliente e da parametrização dos
                  serviços disponibilizados na Plataforma. As instruções para utilização de cada um
                  dos Serviços encontram-se no ambiente da Plataforma.
                </ListItem>
                <ListItem>
                  1.8. Sendo aceitos os termos deste Instrumento, a Daniel concede aos Usuários uma
                  autorização de uso, podendo revogar essa licença conforme condições contratuais.
                </ListItem>
              </UnorderedList>
            </ListItem>

            <ListItem mt="1rem">
              <Text as="b">II. ACESSO E CADASTRO DE USUÁRIOS</Text>
              <UnorderedList listStyleType="none">
                <ListItem>
                  II.1. O Cliente é responsável por cadastrar seus Usuários e Usuários Externos
                  sendo de sua integral responsabilidade a exatidão e autenticidade dos dados
                  inseridos para cadastro.
                </ListItem>

                <ListItem>
                  II.2. A Plataforma não poderá ser responsabilizada por Usuários ou Usuários
                  Externos cadastrados por engano ou má fé por outros Usuários ou terceiros desde
                  que tenha utilizado os dados informados por aqueles que julgarem de boa fé e com
                  razoável expectativa de serem representantes do Cliente.
                </ListItem>
                <ListItem>
                  II.3. A Plataforma também não poderá ser responsabilizada em caso de cadastros não
                  realizados em razão de erros nas informações prestadas pelo Cliente, seus
                  colaboradores, representantes ou Usuários.
                </ListItem>
                <ListItem>
                  II.4. Duas ou mais pessoas físicas não podem usar os Serviços com um único
                  cadastro de Usuário.
                </ListItem>
                <ListItem>
                  II.5. O Cliente poderá designar e expressamente autorizar um (ou mais) Usuário(s)
                  Master(es) como seu agente para gerenciar sua conta com a Daniel e com a
                  Plataforma, o que inclui, por exemplo, ajuste das configurações de administração,
                  concessão de acesso e autorização de uso, solicitação de serviços diversos ou
                  adicionais, fornecimento de registro de utilização e desempenho, aceitação de
                  notificações, divulgações e termos e condições.
                </ListItem>
                <ListItem>
                  II.6. Para utilizar a Plataforma, os Usuários ou Usuários Externos devem ser
                  maiores de 18 (dezoito) anos e possuírem plena capacidade legal para tanto; ou
                  estarem devidamente representados para assumir as responsabilidades aqui
                  estabelecidas.
                </ListItem>
                <ListItem>
                  II.7. O Usuário declara que detém todas as autorizações legais necessárias para
                  fazer o cadastro, aceitar estes Termos de Uso e realizar qualquer operação em nome
                  do Cliente. A Plataforma não será responsável pela falsidade desta declaração,
                  cabendo ao Usuário e ao Cliente o dever de indenizar a Plataforma e terceiros por
                  todos os danos e prejuízos causados.
                </ListItem>
                <ListItem>
                  II.8. A partir do cadastro pelo Cliente, o Usuário será notificado por e-mail, e,
                  após a confirmação de identidade, será designado para editar seu perfil na
                  Plataforma e aceitar os devidos Termos de Uso e Política de Privacidade.
                </ListItem>
                <ListItem>
                  II.9. O Usuário concorda que será responsável pela segurança e sigilo de seu login
                  e senha, responsabilizando-se por todas as ações realizadas em sua conta. Em caso
                  de perda, extravio ou suspeita de utilização indevida de sua conta, login ou
                  senha, o Cliente e a Plataforma (no endereço de e-mail{' '}
                  <a href="mailto:equipe.tecnologia@daniel-ip.com">
                    equipe.tecnologia@daniel-ip.com
                  </a>
                  ) deverão ser imediatamente comunicadas para que sejam tomadas as medidas
                  cabíveis.
                </ListItem>
                <ListItem>
                  II.10. O Cliente é responsável pelas permissões de Usuários designadas por seus
                  representantes e colaboradores, devendo estas serem definidas internamente em
                  linha com seu organograma e organização corporativa.
                </ListItem>
                <ListItem>
                  II.11. A Plataforma não se responsabiliza por danos advindos de permissões de
                  Usuário atribuídas por erro ou má fé por outros Usuários, terceiros,
                  representantes ou colaboradores do Cliente.
                </ListItem>
              </UnorderedList>
            </ListItem>

            <ListItem mt="1rem">
              <Text as="b">III. DISPONIBILIDADE DA PLATAFORMA E SUPORTE</Text>

              <UnorderedList listStyleType="none">
                <ListItem>
                  III.1. A Daniel busca disponibilizar a Plataforma em sua melhor versão possível,
                  atualizando seu sistema constantemente e aplicando as melhores e mais eficientes
                  práticas de mercado. Mesmo diante desses esforços, a Plataforma depende de
                  produtos e serviços de terceiros, tais como smartphones, tablets e computadores,
                  além de provedores de serviços de internet, que devem ser contratados com esses
                  terceiros e compatíveis com o sistema para que o Usuário tenha uma boa experiência
                  de uso. A Daniel não se responsabiliza por falhas nos produtos ou serviços de
                  terceiros que inviabilizem ou impactem a experiência de uso de sua Plataforma.
                </ListItem>
                <ListItem>
                  III.2. Caso o Usuário tenha qualquer problema com o funcionamento regular da
                  Plataforma, poderá contar com a Equipe Daniel no endereço de e-mail{' '}
                  <a href="mailto:equipe.tecnologia@danielip.com">equipe.tecnologia@danielip.com</a>
                  .
                </ListItem>
                <ListItem>
                  III.3. A Daniel não é obrigada a garantir que a Plataforma atenda às necessidades
                  específicas do Cliente e de seus Usuários, tendo em vista que a Plataforma não foi
                  desenvolvida sob medida e não é customizável.
                </ListItem>
                <ListItem>
                  III.4. A Daniel não se responsabiliza por violações dos dados armazenados em seu
                  servidor que sejam resultantes de atos de Usuários ou Usuários Externos,
                  colaboradores e representantes do Cliente, e nem daquelas resultantes de ação
                  criminosa ou irregular de terceiros fora dos limites da previsibilidade técnica do
                  momento em que estas vierem a ocorrer.
                </ListItem>
                <ListItem>
                  III.5. A Daniel poderá, a seu exclusivo critério, desenvolver novas
                  funcionalidades para a Plataforma, podendo, inclusive, cobrar ou não valor
                  adicional por cada nova funcionalidade. Na hipótese de funcionalidades que
                  necessitem de cobrança adicional, somente serão disponibilizadas para o Cliente e
                  seus Usuários se contratadas através da assinatura de aditivo ao contrato firmado
                  com a Daniel.
                </ListItem>
                <ListItem>
                  III.6. A Daniel poderá, também, descontinuar qualquer das funcionalidades que
                  atualmente disponibiliza na Plataforma a seu exclusivo critério. Nessa hipótese,
                  caso a funcionalidade descontinuada faça parte do pacote contratado pelo Cliente,
                  o valor pago por ele será ajustado proporcionalmente a essa alteração.
                </ListItem>
              </UnorderedList>
            </ListItem>

            <ListItem mt="1rem">
              <Text as="b">IV. PROPRIEDADE INTELECTUAL</Text>

              <UnorderedList listStyleType="none">
                <ListItem>
                  IV.1. A Plataforma e seus componentes funcionais e visuais são de titularidade e
                  propriedade exclusiva da Daniel, de forma que os seus direitos autorais e outros
                  direitos de propriedade intelectual são iguais aos conferidos às obras literárias
                  nos moldes da legislação de direitos autorais vigentes no país, conforme expressa
                  determinação da Lei 9.609/98.
                </ListItem>
                <ListItem>
                  IV.2. Inclui-se como propriedade exclusiva da Daniel quaisquer aprimoramentos,
                  correções, traduções, alterações, novas versões ou obras derivadas, realizadas
                  pela Daniel, isoladamente ou em conjunto com terceiros.
                </ListItem>
                <ListItem>
                  IV.3. Na hipótese de a Daniel desenvolver e/ou implementar eventual sugestão do
                  Cliente, Usuários ou Usuários Externos para modificação da Plataforma, os direitos
                  autorais e industriais serão sempre da Daniel.
                </ListItem>
                <ListItem>
                  IV.4. Em hipótese alguma o Cliente e seus Usuários ou Usuários Externos terão
                  acesso ao código fonte da Plataforma e respectivo banco de dados, que são de
                  propriedade exclusiva da Daniel.
                </ListItem>
                <ListItem>
                  IV.5. A Daniel concede uma autorização ao Usuário para uso limitado, não
                  exclusivo, não comercial, pessoal e intransferível, para visualizar, imprimir,
                  descarregar e armazenar os conteúdos contidos na Plataforma apenas pelo tempo de
                  vigência acordado em Contrato. A Daniel poderá tomar todas as medidas judiciais
                  necessárias caso verifique o uso da Plataforma fora desta autorização.
                </ListItem>
              </UnorderedList>
            </ListItem>

            <ListItem mt="1rem">
              <Text as="b">V. PRAZO E RESCISÃO</Text>

              <UnorderedList listStyleType="none">
                <ListItem>
                  V.1. O prazo de vigência dos Serviços será aquele descrito no Contrato.
                </ListItem>
                <ListItem>
                  V.2. Independentemente da forma de rescisão do presente Instrumento e do Contrato,
                  a Daniel oferecerá um prazo de 5 (cinco) dias úteis para que o Cliente faça
                  download dos Documentos e informações contidos na Plataforma. Após esse prazo,
                  tais Documentos e informações serão excluídos.
                </ListItem>
              </UnorderedList>
            </ListItem>

            <ListItem mt="1rem">
              <Text as="b">VI. LIMITAÇÃO DE RESPONSABILIDADE</Text>

              <UnorderedList listStyleType="none">
                <ListItem>
                  VI.1. O Cliente é responsável pela veracidade, legitimidade e qualidade dos dados
                  e Documentos inseridos pelos Usuários ou Usuários Externos na Plataforma e em suas
                  diversas ferramentas. A Daniel está isenta de qualquer responsabilidade quanto aos
                  dados gerados por terceiros a partir das informações inseridas na Plataforma.
                </ListItem>
                <ListItem>
                  VI.2. O Usuário não deverá usar, carregar, transmitir ou enviar de ou para a
                  Plataforma qualquer conteúdo que possa violar a boa-fé, a legislação, ou que possa
                  causar danos à Daniel ou a terceiros. Apesar de não ter obrigação legal de
                  monitoramento, a Daniel, quando ciente do referido conteúdo, poderá excluí-lo a
                  qualquer tempo.
                </ListItem>
                <ListItem>
                  VI.3. A Daniel não tem a obrigação de monitorar o acesso ou uso da Plataforma
                  pelos Usuários ou Usuários Externos para verificar violações a este Instrumento,
                  nem de revisar ou editar qualquer conteúdo. No entanto, a Daniel tem direito de
                  fazê-lo para prestar suporte aos Usuários quando solicitado, averiguar seu
                  cumprimento com estes Termos e para cumprir a lei aplicável ou ordem ou exigência
                  judicial, administrativa ou governamental.
                </ListItem>
                <ListItem>
                  VI.4. Este Instrumento não estabelece qualquer relação de mandato, sociedade e/ou
                  associação, vínculo empregatício, agenciamento, representação, consórcio, joint
                  venture ou responsabilidade solidária entre a Daniel, Cliente e Usuários, que são
                  pessoas independentes e autônomas para todos os fins de direito, tampouco confere
                  poderes a uma das partes para a representação da outra em quaisquer negócios
                  jurídicos. A relação aqui estipulada entre a Daniel e Usuários é válida
                  exclusivamente para o objeto e efeitos deste Instrumento.
                  <UnorderedList listStyleType="none">
                    <ListItem>
                      VI.4.1. Desse modo, a Daniel está isenta de responsabilidade perante a
                      eventual existência de interpelação judicial ou administrativa cujos fatos
                      fundamentem-se em conflitos entre o Cliente e seus colaboradores,
                      representantes ou prepostos, Usuários ou Usuários Externos, e
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  VI.5. A Daniel não se responsabiliza por quaisquer danos sofridos, a despeito de
                  seus esforços, em decorrência de ataques de vírus ou invasões sobre o equipamento
                  do Usuário ou Usuário Externo em decorrência do acesso, utilização ou navegação
                  por meio da Plataforma, ou como consequência da transferência de dados, arquivos,
                  imagens ou textos.
                </ListItem>
                <ListItem>
                  VI.5. A Daniel não se responsabiliza por quaisquer danos sofridos, a despeito de
                  seus esforços, em decorrência de ataques de vírus ou invasões sobre o equipamento
                  do Usuário ou Usuário Externo em decorrência do acesso, utilização ou navegação
                  por meio da Plataforma, ou como consequência da transferência de dados, arquivos,
                  imagens ou textos.
                  <UnorderedList listStyleType="none">
                    <ListItem>
                      (i) manter o ambiente de seus computadores e demais dispositivos de acesso à
                      Plataforma seguros, valendo-se de ferramentas específicas para tanto, tais
                      como antivírus, firewall, entre outras, de modo a contribuir para a prevenção
                      de riscos eletrônicos;
                    </ListItem>
                    <ListItem>
                      (ii) utilizar sistemas operacionais e navegadores atualizados e eficientes
                      para a plena utilização da Plataforma, de acordo com os requisitos da
                      Plataforma; e
                    </ListItem>
                    <ListItem>
                      (iii) equipar-se e responsabilizar-se pelos computadores, dispositivos móveis
                      e dispositivos de hardware necessários para o acesso à Plataforma, bem como
                      pelo acesso desses computadores e dispositivos à Internet.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  VI.7. Qualquer violação às obrigações do Usuário descritas neste Instrumento que
                  possam representar uma possível falha na segurança do funcionamento da Plataforma
                  e na prestação dos Serviços, ainda que potencial, poderá representar uma violação
                  aos termos deste Instrumento, ensejando a suspensão dos Serviços até a
                  normalização da Plataforma, ou mesmo a rescisão do presente Instrumento.
                </ListItem>
              </UnorderedList>
            </ListItem>
            <ListItem mt="1rem">
              <Text as="b">VII. CONFIDENCIALIDADE</Text>

              <UnorderedList listStyleType="none">
                <ListItem>
                  VII.1. Todas as informações trocadas entre o Cliente, seus Usuários, a Daniel e
                  Usuário Externo são consideradas Informações Confidenciais. O Cliente, seus
                  Usuários, a Daniel e Usuários Externos cadastrados garantem que tratarão as
                  informações com o sigilo e discrição necessários à prestação dos Serviços,
                  responsabilizando-se por eventuais divulgações indevidas.
                </ListItem>
                <ListItem>
                  VII.2. Todas as informações relacionadas ao Contrato e eventual proposta comercial
                  enviada à Empresa deverão ser entendidas como Informações Confidenciais.
                </ListItem>
                <ListItem>
                  VII.3. O conteúdo dos Documentos compartilhados por meio da Plataforma serão
                  também considerados confidenciais a não ser que disposto em contrário dentro dos
                  seus próprios termos.
                </ListItem>
                <ListItem>
                  VII.4. Durante e após a vigência do Contrato, a parte que recebe as Informações
                  Confidenciais deverá: (a) usar as Informações Confidenciais da outra parte apenas
                  para os fins para que foram fornecidas; (b) não divulgar tais Informações
                  Confidenciais a terceiros, exceto na medida do necessário (need-to-know basis)
                  para seus advogados, auditores, consultores, e prestadores de serviços que estejam
                  sob obrigações de confidencialidade que sejam, ao menos, tão restritivas quanto as
                  disposições contidas no presente Instrumento; e (c) proteger tais Informações
                  Confidenciais contra uso e divulgação não autorizados na mesma medida (mas usando
                  nada menos do que um grau razoável de cuidado) em que protege suas próprias
                  Informações Confidenciais de natureza similar.
                </ListItem>
              </UnorderedList>
            </ListItem>

            <ListItem mt="1rem">
              <Text as="b">VIII. SOBRE A PROTEÇÃO DE DADOS PESSOAIS</Text>

              <UnorderedList listStyleType="none">
                <ListItem>
                  VIII.1. A Daniel trata dados pessoais para a realização dos Serviços, para cumprir
                  com a legislação aplicável e para exercer seus interesses legítimos como
                  Controladora de dados, nos termos da Legislação de Privacidade.
                </ListItem>
                <ListItem>
                  VIII.2. Os dados pessoais coletados pela Daniel podem ser divididos em duas
                  categorias:
                  <UnorderedList listStyleType="none">
                    <ListItem>
                      <b>(i) Dados coletados automaticamente:</b> são os Dados Pessoais coletados
                      automaticamente quando os Usuários navegam pela Plataforma, como endereço IP,
                      localização, data e hora de acessos, cookies, dados de acesso e atividades
                      realizadas dentro da Plataforma;
                    </ListItem>
                    <ListItem>
                      <b>(ii) Dados fornecidos pelos Usuários e pelo Cliente:</b> são os dados
                      inseridos pelos Usuários no momento de cadastro na Plataforma, como nome,
                      e-mail e área de atuação.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  VIII.3. A Daniel não compartilha os dados pessoais que trata por meio da
                  Plataforma a não ser com operadores e fornecedores de serviços que participam,
                  direta ou indiretamente, do desenvolvimento das atividades comerciais da Daniel,
                  como serviços de hospedagem ou armazenamento de dados.
                </ListItem>
                <ListItem>
                  VIII.4. Ao compartilhar seus Dados Pessoais a Daniel toma as medidas de segurança
                  contratuais necessárias para proibir o uso de suas informações para outras
                  finalidades, incluindo fins demarketing, além de exigir desses terceiros que
                  protejam adequadamente seus Dados Pessoais.
                </ListItem>
                <ListItem>
                  VIII.5. A Daniel armazenará os Dados Pessoais coletados durante todo o tempo em
                  que os Usuários se mantiverem cadastrados nos Serviços e na Plataforma, pelo tempo
                  que for necessário para cumprir com o objetivo para o qual foram coletados, ou
                  mediante solicitação do titular, conforme explorado neste Instrumento.
                </ListItem>
                <ListItem>
                  VIII.6. Além disso, os dados poderão ser armazenados por período:
                  <UnorderedList listStyleType="none">
                    <ListItem>
                      <b>(i)</b> Prescricional possivelmente vinculado à relação jurídica com o
                      titular;
                    </ListItem>
                    <ListItem>
                      <b>(ii)</b> Necessário a uma eventual negociação contratual;
                    </ListItem>
                    <ListItem>
                      <b>(iii)</b> Necessário para o cumprimento de eventual obrigação legal ou
                      regulatória; ou
                    </ListItem>
                    <ListItem>
                      <b>(iv)</b> Caso haja outro motivo justo para armazená-lo.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  VIII.7. Quando os Dados Pessoais que coletamos não forem mais necessários, a
                  Daniel os excluirá de forma segura ou os tornará anônimos para que não possam ser
                  associados ou rastreados de volta ao Usuário.
                </ListItem>
                <ListItem>
                  VIII.8. A Plataforma utiliza os seguintes cookies:
                  <UnorderedList listStyleType="none">
                    <ListItem>
                      <b>(i) Cookies Necessários:</b> para que os Serviços e a Plataforma carreguem
                      corretamente e permita que o Usuário navegue e faça uso de todas as
                      funcionalidades disponíveis, normalmente.
                    </ListItem>
                    <ListItem>
                      <b>(ii) Cookies Funcionais: </b>que permitem que os Serviços e a Plataforma se
                      lembrem das escolhas dos Usuários, para proporcionar uma experiência mais
                      personalizada. Também, possibilitam que os Usuários assistam a vídeos e
                      utilizem ferramentas sociais, campos para comentários, fóruns, entre outros
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  VIII.9. São direitos dos Usuários, nos termos do artigo 18 da LGPD:
                  <UnorderedList listStyleType="none">
                    <ListItem>(i) Confirmação da existência de tratamento;</ListItem>
                    <ListItem>(ii) Acesso aos dados coletados;</ListItem>
                    <ListItem>
                      (iii) Correção de dados incompletos, inexatos ou desatualizados;
                    </ListItem>
                    <ListItem>
                      (iv) Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos
                      ou tratados em desconformidade com a Legislação de Privacidade;
                    </ListItem>
                    <ListItem>
                      (v) Portabilidade de dados dos Usuários a outro fornecedor de serviços ou
                      produto; mediante requisição expressa dos Usuários;
                    </ListItem>
                    <ListItem>
                      (vi) Eliminação dos dados tratados com o consentimento dos Usuários;
                    </ListItem>
                    <ListItem>
                      (vii) Obtenção de informações sobre as entidades públicas ou privadas com as
                      quais tenha compartilhado os Dados Pessoais;
                    </ListItem>
                    <ListItem>
                      (viii) Informação sobre a possibilidade dos Usuários não fornecerem
                      consentimento para a coleta de dados, bem como informação acerca das
                      consequências do não consentimento;
                    </ListItem>
                    <ListItem>
                      (viii) Informação sobre a possibilidade dos Usuários não fornecerem
                      consentimento para a coleta de dados, bem como informação acerca das
                      consequências do não consentimento;
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  VIII.10. O Usuário pode entrar em contato com o Encarregado pela proteção de dados
                  da Daniel com segurança e confidencialidade a qualquer momento para exercer seus
                  direitos, sanar dúvidas, preocupações, ou qualquer problema relacionado a proteção
                  de dados pessoais pelo e-mail:{' '}
                  <a href="mailto:dpo@daniel-ip.com">dpo@daniel-ip.com</a>.
                </ListItem>
                <ListItem>
                  VIII.11. A Daniel poderá vir a ser obrigada a manter dados pessoais mesmo após
                  receber a notícia de revogação de autorização, ou mesmo após o pedido de exclusão,
                  caso seja necessário para cumprimento de obrigações legais, resolver disputas,
                  manter a segurança, evitar fraudes e/ou garantir o cumprimento de contratos.
                </ListItem>
                <ListItem>
                  VIII.12. A exclusão das informações básicas para registro nos Serviços e na
                  Plataforma implicará no término do cadastro dos Usuários e no cancelamento dos
                  Serviços prestados.
                </ListItem>
                <ListItem>
                  VIII.13. Os Usuários também têm o direito de apresentar uma reclamação junto à
                  Autoridade Nacional de Proteção de Dados (ANPD), porém a Daniel os encoraja a
                  tratar de eventuais dúvidas ou solicitações diretamente com a Equipe Daniel, para
                  uma solução mais rápida.
                </ListItem>
                <ListItem>
                  VIII.14. A Daniel utiliza uma variedade de{' '}
                  <b>padrões de segurança física, técnica e administrativa</b> para ajudar a
                  proteger os dados pessoais contra incidentes de segurança, tais como a perda, o
                  mau uso, a alteração, a destruição ou a ocorrência de danos, dependendo da
                  sensibilidade da informação.
                </ListItem>
                <ListItem>
                  VIII.15. A Daniel toma medidas para <b>limitar o acesso aos Dados Pessoais</b> dos
                  Usuários às pessoas que precisam ter acesso a eles para uma das finalidades
                  listadas nestes Termos. Além disso, a Daniel <b>contratualmente assegura</b> que
                  quaisquer terceiros processando dados pessoais também garantam a confidencialidade
                  e a integridade dos dados.
                </ListItem>
                <ListItem>
                  VIII.16. No entanto, apesar dos melhores esforços, é impossível garantir que
                  agentes malintencionados não conseguirão ter acesso ou fazer uso indevido dos
                  dados pessoais. Por esse motivo, a Daniel incentiva seus Usuários a sempre tomarem
                  cuidado com sua própria segurança, mantendo confidenciais seu nome de usuário e
                  senhas, e navegar em redes seguras.
                </ListItem>
              </UnorderedList>
            </ListItem>

            <ListItem mt="1rem">
              <Text as="b">IX. DISPOSIÇÕES FINAIS</Text>

              <UnorderedList listStyleType="none">
                <ListItem>
                  IX.1. <b>Sucessão.</b> Este Instrumento vincula as partes e seus sucessores, sejam
                  eles a qualquer título.
                </ListItem>
                <ListItem>
                  IX.2. <b>Cessão.</b> Os direitos concedidos de acordo com o presente Instrumento
                  não podem ser transferidos ou cedidos pelo Cliente ou seus Usuários, mas podem ser
                  transferidos pela Daniel sem qualquer restrição ou notificação prévia, assumindo
                  esse terceiro todas as obrigações constantes neste Instrumento.
                </ListItem>
                <ListItem>
                  IX.3. <b>Novação.</b> A tolerância da Daniel em exigir o estrito cumprimento das
                  condições deste Instrumento, não constitui, em hipótese alguma, novação ou
                  renúncia, nem impede que a Daniel exerça esses direitos a qualquer tempo.
                </ListItem>
                <ListItem>
                  IX.4. <b>Subsistência.</b> Todas as disposições deste Instrumento que prevejam a
                  observância de obrigações ou responsabilidades após a rescisão ou extinção deste
                  Instrumento e/ou dos Serviços, subsistirão à sua rescisão ou extinção e
                  continuarão em pleno vigor e efeito, em especial no que tange à propriedade
                  intelectual e confidencialidade.
                </ListItem>
                <ListItem>
                  IX.5. <b>Cláusulas Independentes.</b> Se alguma cláusula deste Instrumento for
                  considerada ilegal, nula ou incapaz de ser cumprida por qualquer motivo, esta
                  previsão será considerada uma cláusula independente da parte remanescente deste
                  Instrumento e não afetará a validade ou a aplicabilidade do cumprimento dos termos
                  do restante do presente.
                </ListItem>
                <ListItem>
                  IX.6. <b>Lei aplicável e foro.</b> Todos os itens deste Instrumento estão regidos
                  pelas leis vigentes na República Federativa do Brasil. Para todos os assuntos
                  referentes à sua interpretação e cumprimento, as partes se submeterão ao foro da
                  Comarca do Rio de Janeiro, estado do Rio de Janeiro.
                </ListItem>
                <ListItem>
                  IX.7. <b>Alterações.</b> A Daniel reserva-se ao direito de alterar as condições
                  deste Instrumento a qualquer momento, informando o Cliente e seus Usuários sobre
                  tais mudanças posteriormente.
                </ListItem>
              </UnorderedList>
            </ListItem>
          </UnorderedList>

          <Flex mt="2rem">
            <Flex ml="auto">Última alteração: setembro/2021</Flex>
          </Flex>
        </Box>
      </Box>
    </Styles.Container>
  );
};
